const normalizePatientId = (patientId) => String(patientId || "").trim();

export const selectNephrologyHistoryByPatientId = (state, patientId) =>
  state.nephrology?.historyByPatientId?.[normalizePatientId(patientId)] || [];

export const selectNephrologyHistoryFetchStatus = (state, patientId) =>
  state.nephrology?.fetchStatusByPatientId?.[normalizePatientId(patientId)] || "idle";

export const selectNephrologyHistoryFetchError = (state, patientId) =>
  state.nephrology?.fetchErrorByPatientId?.[normalizePatientId(patientId)] || null;

export const selectNephrologyHistorySaveStatus = (state, patientId) =>
  state.nephrology?.saveStatusByPatientId?.[normalizePatientId(patientId)] || "idle";

export const selectNephrologyHistorySaveError = (state, patientId) =>
  state.nephrology?.saveErrorByPatientId?.[normalizePatientId(patientId)] || null;

export const selectNephrologyExamByPatientId = (state, patientId) =>
  state.nephrology?.examByPatientId?.[normalizePatientId(patientId)] || [];

export const selectNephrologyExamFetchStatus = (state, patientId) =>
  state.nephrology?.examFetchStatusByPatientId?.[normalizePatientId(patientId)] || "idle";

export const selectNephrologyExamFetchError = (state, patientId) =>
  state.nephrology?.examFetchErrorByPatientId?.[normalizePatientId(patientId)] || null;

export const selectNephrologyUrinaryAndUremiaByPatientId = (state, patientId) =>
  state.nephrology?.urinaryAndUremiaByPatientId?.[normalizePatientId(patientId)] || [];

export const selectNephrologyUrinaryAndUremiaFetchStatus = (state, patientId) =>
  state.nephrology?.urinaryAndUremiaFetchStatusByPatientId?.[normalizePatientId(patientId)] || "idle";

export const selectNephrologyUrinaryAndUremiaFetchError = (state, patientId) =>
  state.nephrology?.urinaryAndUremiaFetchErrorByPatientId?.[normalizePatientId(patientId)] || null;